/*
 * Copyright 2014-2015 Hippo B.V. (http://www.onehippo.com)
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *  http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function () {
  "use strict";

  angular.module('hippo.theme')
  /**
   * @ngdoc directive
   * @name hippo.theme.directive:a
   * @restrict E
   *
   * @description
   * Blurs an anchor when it is clicked. This removes the default outline for clicked anchors in multiple browsers.
   */
    .directive('a', function () {
      return {
        restrict: 'E',
        link: function (scope, element) {
          element.on('click', function () {
            element.blur();
          });
        }
      };
    })

  /**
   * @ngdoc directive
   * @name hippo.theme.directive:button
   * @restrict E
   *
   * @description
   * Blurs a button when it is clicked. This removes the default outline for clicked buttons in multiple browsers.
   */
    .directive('button', function () {
      return {
        restrict: 'E',
        link: function (scope, element) {
          element.on('click', function () {
            element.blur();
          });
        }
      };
    });

}());
